export default class Modal {
    static init() {
        new Modal();
    }

    constructor() {
        this.idleListener();
        window.addEventListener('click', (e) => {
            const modalLink = e.target.dataset.toggle ==='modal' ? e.target : false;
            const modalClose = e.target.classList.contains('modal__close') ? e.target : false;
            const modalBackdrop = e.target.classList.contains('modal__backdrop') ? e.target : false;

            if (modalLink) {
                let modal = document.querySelector(modalLink.dataset.target);

                if (modal) {
                    modal.classList.add('visible');
                }
            }

            if (modalClose) {
                let modal = modalClose.closest('.modal')
                modal.classList.remove('visible');
            }

            if (modalBackdrop) {
                let modal = modalBackdrop.closest('.modal');
                modal.classList.remove('visible');
            }
        });

        let timerModals = Array.from(document.querySelectorAll('[data-trigger*="timer"]'));

        // show by timer, but only once per session
        if (timerModals) timerModals.map(el => {
            if (this.isShownBefore(el.id)) return;
            setTimeout(() => {
                this.show(el);
                sessionStorage.setItem('modal-shown-' + el.id, 'true');
            }, parseInt(el.dataset.appearsAfterSeconds) * 1000);
        });

        // show each time user switch to another tab/window
        let leaveModals = Array.from(document.querySelectorAll('[data-trigger*="leave"]'));
        if (leaveModals) {
            document.addEventListener('visibilitychange', () => {
                leaveModals.map(el => {
                    this.show(el);
                });
            });

            document.addEventListener('mouseleave', (event) => {
                // The cursor left the document at the top edge (<= 10px from top).
                if (event.relatedTarget === null && event.clientY <= 10) {
                    leaveModals.map(el => {
                        if (this.isShownBefore(el.id)) return;
                        this.show(el);
                        sessionStorage.setItem('modal-shown-' + el.id, 'true');
                    });
                }
            });
        }

        // show each time tab is inactive for 60 seconds
        let idleModals = Array.from(document.querySelectorAll('[data-trigger*="idle"]'));
        window.addEventListener('idle', () => {
            idleModals.map(el => {
                this.show(el);
            });
        });
    }

    show(el){
        if (!el.classList.contains('visible')) el.classList.add('visible');
    }

    isShownBefore = (id) => !!sessionStorage.getItem('modal-shown-' + id);

    idleListener() {
        let time = 0;
        let resetTimer = () => {
            clearTimeout(time)
            time = setTimeout(() => window.dispatchEvent(new CustomEvent('idle')), 60000);
        }

        window.addEventListener('load', resetTimer, true);
        let events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
        events.map((event) => {
            document.addEventListener(event, resetTimer, true);
        });
    }
}
